import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Footer.css';
import logo from '../assests/logo.png';

/* ── Social icons ── */
function IconLinkedIn() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  );
}
// function IconTwitter() {
//   return (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//       <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
//     </svg>
//   );
// }
function IconInstagram() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
    </svg>
  );
}
// function IconGithub() {
//   return (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//       <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
//     </svg>
//   );
// }
// function IconYoutube() {
//   return (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//       <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//     </svg>
//   );
// }

const SOCIALS = [
  { label: 'Instagram', Icon: IconInstagram, href: 'https://www.instagram.com/skillsync_pvt.ltd/'},
  { label: 'LinkedIn',  Icon: IconLinkedIn,  href: 'https://linkedin.com' },
  
];

const SERVICES = [
  { label: 'Web Development',    path: '/services#web'    },
  { label: 'Mobile Apps',        path: '/services#mobile' },
  { label: 'UI/UX Design',       path: '/services#design' },
  { label: 'Cloud Solutions',    path: '/services#cloud'  },
  { label: 'IT Consulting',      path: '/services#consult'},
  { label: 'Software Development',       path: '/services#software'},
];

const COMPANY = [
  { label: 'About Us',   path: '/about'     },
  { label: 'Portfolio',  path: '/portfolio' },
  { label: 'Career',     path: '/career'    },
  { label: 'Contact',    path: '/contact'   },
 
];

const LEGAL = [
  { label: 'Privacy Policy',    path: '/privacy'  },
  { label: 'Terms of Service',  path: '/terms'    },
  { label: 'Cookie Policy',     path: '/cookies'  },
  { label: 'Sitemap',           path: '/sitemap'  },
];

export default function Footer() {
  const [email, setEmail]   = useState('');
  const [subState, setSubState] = useState('idle'); // idle | success | error
  const navigate = useNavigate();

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) { setSubState('error'); return; }
    setSubState('success');
    setEmail('');
    setTimeout(() => setSubState('idle'), 3500);
  };

  // Logo click → go home + jump to top
  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Any internal footer link click → scroll to top after navigating
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">

      {/* ── TOP GRADIENT BAND ── */}
      <div className="footer__topband" />

      {/* ── MAIN CONTENT ── */}
      <div className="footer__main">
        <div className="footer__inner">

          {/* COL 1 — Brand */}
          <div className="footer__brand">
            <a href="/" className="footer__logo-link" onClick={handleLogoClick}>
              <img src={logo} alt="SkillSync Pro" className="footer__logo" />
            </a>
            <p className="footer__tagline">
              Crafting digital solutions that scale. From Nagercoil, Tamil Nadu — building for the world.
            </p>

            {/* Socials */}
            <div className="footer__socials">
              {SOCIALS.map(({ label, Icon, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="footer__social-btn"
                >
                  <Icon />
                </a>
              ))}
            </div>

            {/* Contact info */}
            <div className="footer__contact-info">
              <a href="mailto:hr@skillsyncpro.in" className="footer__contact-row">
                <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                  <rect x="2" y="4" width="16" height="13" rx="2" stroke="currentColor" strokeWidth="1.6"/>
                  <path d="M2 7l8 5 8-5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
                hr@skillsyncpro.in
              </a>
              <a href="tel:+919876543210" className="footer__contact-row">
                <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                  <path d="M4 2h3l1.5 4-2 1.5a11 11 0 005 5L13 10.5l4 1.5v3a2 2 0 01-2 2A16 16 0 012 4a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
                </svg>
                +91 8248609829
              </a>
              <span className="footer__contact-row footer__contact-addr">
                <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                  <path d="M10 2a6 6 0 016 6c0 4-6 10-6 10S4 12 4 8a6 6 0 016-6z" stroke="currentColor" strokeWidth="1.6"/>
                  <circle cx="10" cy="8" r="2" stroke="currentColor" strokeWidth="1.6"/>
                </svg>
                Nagercoil, Tamil Nadu, India
              </span>
            </div>
          </div>

          {/* COL 2 — Services */}
          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            <ul className="footer__col-list">
              {SERVICES.map(({ label, path }) => (
                <li key={label}>
                  <NavLink to={path} className="footer__col-link" onClick={handleLinkClick}>{label}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* COL 3 — Company */}
          <div className="footer__col">
            <h4 className="footer__col-title">Company</h4>
            <ul className="footer__col-list">
              {COMPANY.map(({ label, path }) => (
                <li key={label}>
                  <NavLink to={path} className="footer__col-link" onClick={handleLinkClick}>{label}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* COL 4 — Newsletter */}
          <div className="footer__col footer__col--news">
            <h4 className="footer__col-title">Stay Updated</h4>
            <p className="footer__news-desc">
              Get the latest in tech trends, project insights, and company updates.
            </p>
            <form className="footer__form" onSubmit={handleSubscribe} noValidate>
              <div className={`footer__form-wrap ${subState === 'error' ? 'footer__form-wrap--err' : ''}`}>
                <input
                  type="email"
                  placeholder="your@email.com"
                  className="footer__input"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setSubState('idle'); }}
                  aria-label="Email address"
                />
                <button type="submit" className="footer__form-btn">
                  <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                    <path d="M4 10h12M12 6l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
              {subState === 'success' && (
                <p className="footer__form-msg footer__form-msg--ok">
                  ✓ You're subscribed!
                </p>
              )}
              {subState === 'error' && (
                <p className="footer__form-msg footer__form-msg--err">
                  Please enter a valid email.
                </p>
              )}
            </form>

            {/* Tech badges
            <div className="footer__badges">
              {['React', 'Node.js', 'AWS', 'Flutter', 'TypeScript'].map((t) => (
                <span key={t} className="footer__badge">{t}</span>
              ))}
            </div> */}
          </div>

        </div>
      </div>

      {/* ── BOTTOM BAR ── */}
      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <span className="footer__copy">
            © {new Date().getFullYear()} SkillSync Pro Pvt Ltd. All rights reserved.
          </span>
          <div className="footer__legal">
            {LEGAL.map(({ label, path }, i) => (
              <span key={label} className="footer__legal-item">
                {i > 0 && <span className="footer__legal-sep">·</span>}
                <NavLink to={path} className="footer__legal-link" onClick={handleLinkClick}>{label}</NavLink>
              </span>
            ))}
          </div>
          <span className="footer__made">
            Made with <span className="footer__heart">♥</span> in Nagercoil
          </span>
        </div>
      </div>

    </footer>
  );
}